import { useState } from 'react';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import type { IOptOutModel, IOptOutSubmitResult } from '@/types/history/opt-out';

const OPT_OUT_ENDPOINT = '/api/register/opt-out';

const defaultOptOutModel: IOptOutModel = {
    id: 0,
    editKey: '',
    isIE: false,

    stopCommunication: false,

    languageData: {},
};

type TOptOutResult = IOptOutSubmitResult & { results?: Partial<IOptOutModel> };

export const useOptOut = (registrationId: number, editKey: string) => {
    const url = `${OPT_OUT_ENDPOINT}/${registrationId}/${editKey}`;

    const { model: loaded, isLoading, error } = useApiModel(url, defaultOptOutModel);
    const [override, setOverride] = useState<IOptOutModel | null>(null);
    const model = override ?? loaded;

    const { submit: post, isSubmitting, submitError } = useApiSubmit<void, Partial<IOptOutModel>, TOptOutResult>(
        url,
        () => ({}),
        (results) => ({ results }),
    );

    const submit = (): Promise<IOptOutSubmitResult> =>
        post().then(({ results, ...result }) => {
            // The refreshed model flips the page to its confirmation state.
            if (results) setOverride({ ...defaultOptOutModel, ...results });

            return result;
        });

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
